import { Input, Node, Output } from "rete"
import { BooleanTileGrid, CategoricalTileGrid } from "../tile_grid"
import { BaseComponent } from "./base_component"
import { booleanDataSocket, categoricalDataSocket } from "../socket_types"
import { NodeData, WorkerInputs, WorkerOutputs } from "rete/types/core/data"

export class CatIntersectComponent extends BaseComponent {

    constructor() {
        super('Categorical intersect')
        this.category = 'Set operations'
    }


    async builder(node: Node) {
        node.addInput(new Input('cat_in', 'Categorical input', categoricalDataSocket))
        node.addInput(new Input('bool_in', 'Boolean input', booleanDataSocket))
        node.addOutput(new Output('out', 'Output', categoricalDataSocket))
    }

    async worker(node: NodeData, inputs: WorkerInputs, outputs: WorkerOutputs, ...args: unknown[]) {
        const editorNode = this.editor?.nodes.find(n => n.id === node.id)
        if (editorNode === undefined) { return }

        const categoricalData = inputs['cat_in']
        if (categoricalData.length === 0) { return }

        const booleanData = inputs['bool_in']
        if (booleanData.length === 0) { return }

        const cat_in = categoricalData[0] as CategoricalTileGrid
        const bool_in = booleanData[0] as BooleanTileGrid

        const out = new CategoricalTileGrid(cat_in.zoom, cat_in.x, cat_in.y, cat_in.width, cat_in.height)
        out.setLabels(cat_in.labels)

        cat_in.iterate((x, y, value) => {
            if (bool_in.get(x, y, cat_in.zoom)) {
                out.set(x, y, value)
            }
        })

        out.name = editorNode.data.name as string ?? 'Categorical intersect'

        outputs['out'] = out
    }

}
